// src/hooks/coinglass/useGlobalM2Chart.ts

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { globalM2ChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { GlobalM2QueryParams } from "@/types/indices";

/**
 * Custom hook for fetching Bitcoin vs Global M2 chart data
 *
 * @param params - Optional query parameters (token_id, start_date, end_date, limit)
 * @returns Query result with chart data
 */
export function useGlobalM2Chart(params?: GlobalM2QueryParams) {
  const query = useQuery(globalM2ChartQueryOptions(params));

  useEffect(() => {
    console.log("[Hook] useGlobalM2Chart params:", params);
    if (query.isLoading) console.log("[Hook] useGlobalM2Chart loading...");
    if (query.isError)
      console.error("[Hook] useGlobalM2Chart error:", query.error);
    if (query.data) {
      console.log("[Hook] useGlobalM2Chart data received");
      console.log("[Hook] useGlobalM2Chart parsed data:", {
        hasXAxis: !!query.data?.data?.xAxis,
        hasSeries: !!query.data?.data?.series,
        xAxisLength: query.data?.data?.xAxis?.length,
        seriesCount: query.data?.data?.series?.length,
        firstXAxisValue: query.data?.data?.xAxis?.[0],
        lastXAxisValue:
          query.data?.data?.xAxis?.[query.data?.data?.xAxis?.length - 1],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        seriesNames: query.data?.data?.series?.map((s: any) => s.name),
      });
    }
  }, [query.isLoading, query.isError, query.data, query.error, params]);

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
